window.MultiStorefront = class Storefront {
  static API_URL = '';
  static token = '';

  static init(url, token) {
    this.API_URL = `${url}/api/storefront`;
    this.token = token;
  }

  static async fetch(input, init) {
    const response = await fetch(input, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${this.token}`,
      },
      ...(init || {}),
    });

    const body = await response.text();
    try {
      return JSON.parse(body);
    } catch (err) {
      return body;
    }
  }

  static async get(url) {
    return await this.fetch(`${this.API_URL}${url}`);
  }

  static async post(url, data) {
    return await this.fetch(`${this.API_URL}${url}`, {
      method: 'POST',
      body: JSON.stringify(data || {}),
    });
  }
};